import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Save } from "lucide-react";
import { Position } from "@/types/locationTypes";

interface TrackingControlsProps {
  isTracking: boolean;
  startTracking: () => void;
  stopTracking: () => void;
  resetTracking: () => void;
  onSaveClick: () => void;
  startPosition: Position | null;
  endPosition: Position | null;
  distance: number | null;
}

export const TrackingControls: React.FC<TrackingControlsProps> = ({
  isTracking,
  startTracking,
  stopTracking,
  resetTracking,
  onSaveClick,
  startPosition,
  endPosition,
  distance
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col space-y-2">
      {!isTracking ? (
        <Button onClick={startTracking} variant="default" className="w-full">
          {t("ballDistance.tracking.startTracking")}
        </Button>
      ) : (
        <Button onClick={stopTracking} variant="default" className="w-full">
          {t("ballDistance.tracking.stopAndCalculate")}
        </Button>
      )}
      
      {!isTracking && startPosition && endPosition && distance && (
        <Button 
          onClick={onSaveClick} 
          variant="outline" 
          className="w-full"
        >
          <Save className="h-4 w-4 mr-2" />
          {t("ballDistance.tracking.saveToHistory")}
        </Button>
      )}
      
      <Button
        onClick={resetTracking}
        variant="outline"
        className="w-full"
        disabled={!startPosition}
      >
        {t("ballDistance.tracking.reset")}
      </Button>
    </div>
  );
};
